/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Entry Judging.
 * UI and Fetch routines for judging entries including voting. 
 * 
 * @author John Pobojewski <https://john.pobojewski.com>
 */

import Modal from "/src/scripts/components/Modal.js";

class EntryJudging {
  submitVotes() {
    // cue spinner
    Modal.processing();

    const form = document.getElementById('voting');
    const formData = new FormData(form);
    const data = new URLSearchParams(formData).toString();

    fetch('/actions/entries/save-entry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data,
      })
      .then(response => {
        console.log(response);
        if (response.ok) {
          
          Modal.alert([{ value: 'vote-updated' }]);
        } else {
          // error detection tk
          console.error('Vote submission failed:', response);
        }
      })
      .catch(error => {
        console.error('Network error:', error);
      });
  }

  init(ajaxToggle) {
    console.log('EntryJudging.init()');

    const form = document.getElementById('voting');
    const voteToggles = document.querySelectorAll('.voteToggle');
    const submitButton = form.querySelector('button[type="submit"]');

    if (ajaxToggle) {
      // hide judging submit
      if (submitButton) {
        submitButton.style.display = 'none';
      }

      voteToggles.forEach(toggle => {
        toggle.addEventListener('change', () => {
          this.submitVotes();
        });
      });
    } else {
      form.addEventListener('submit', e => {
        e.preventDefault();
        this.submitVotes();
      });
    }
  }
}

export default new EntryJudging();
